<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.campaigns') }}
        </div>
        <div class="va-card__header-actions">
          <va-button small icon="fa fa-plus" to="/kampanya/ekleme">{{ $t('tables.actions.create') }}</va-button>
        </div>
      </template>

      <div class="row align--center">
        <div class="flex xs12 md6"></div>
        <div class="flex xs12 md3 offset--md3"></div>
      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
        @row-clicked="show"
      >
        <template slot="start_at" slot-scope="props">
          {{ formatDate(props.rowData.start_at) }}
        </template>

        <template slot="end_at" slot-scope="props">
          {{ formatDate(props.rowData.end_at) }}
        </template>

        <template slot="value" slot-scope="props">
          <va-badge :color="getCampaignColor(props.rowData)">
            {{ getCampaignValue(props.rowData) }}
          </va-badge>
        </template>

        <template slot="actions" slot-scope="props" custom-key="actions">
          <va-popover :message="`${$t('tables.actions.translate')} ` + (props.rowData.title.en ? `${$t('tables.actions.edit')}` : `${$t('tables.actions.add')}`)" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small :color="props.rowData.title.en ? 'info' : 'gray'" class="ma-0" @click.stop="buttonAsHref('/kampanya/'+props.rowData.id+'/ceviri')">
              {{ $t('tables.actions.english') }}
            </va-button>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.edit')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="info" icon="fa fa-pencil" @click.stop="buttonAsHref('/kampanya/'+props.rowData.id+'/duzenleme')"/>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.destroy')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="warning" icon="fa fa-trash" @click.stop="confirmDeleteCampaign(props.rowData)" />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-pagination
      v-model="pages.current_page"
      :visible-pages="3"
      :pages="pages.last_page"
      class="mt-3"
      :small="true"
      color="secondary"
    />
  </div>
</template>

<script>
import moment from "moment"
import campaignServices from '../../services/api/campaign'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
      pages: {
        current_page: 1,
        last_page: 1
      }
    }
  },
  computed: {
    fields () {
      return [{
        name: 'name',
        title: this.$t('tables.headings.campaign.name'),
        width: '40%',
      }, {
        name: '__slot:start_at',
        title: this.$t('tables.headings.campaign.startAt'),
      }, {
        name: '__slot:end_at',
        title: this.$t('tables.headings.campaign.endAt'),
      }, {
        name: '__slot:value',
        title: this.$t('tables.headings.campaign.value'),
      }, {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  watch: {
    'pages.current_page': function(val) {
      let q = {};
      q.sayfa = val;
      this.$router.push({ path: '/kampanya/listesi', query: q });
      this.getCampaigns(val);
    },
    '$route.query'(val) {
      this.splitQuery(val);
    }
  },
  methods: {
    async getCampaigns(page=1, filter = {}){
      this.loading = true;

      filter.page = page;
      filter.limit = 15;
      filter.sort = '-id';

      const result = await campaignServices.get('', {
          params: filter
        });
      if(result.error){
        this.items = [];
        return ;
      }
      this.loading = false;
      this.items = result.data.data;
      this.pages = result.data.meta;
    },
    formatDate (date) {
      if (date) {
        return moment(String(date)).format("DD.MM.YYYY");
      }
      return date;
    },
    getCampaignColor (campaign) {
      if (campaign.apply_type === 'decrease') {
        return 'danger'
      }

      return 'info'
    },
    getCampaignValue (campaign) {
      let sign = campaign.apply_type === 'decrease' ? '-' : '+',
          value = campaign.amount,
          type = campaign.amount_type === 'percent' ? '%' : '₺';
      return sign + value + type;
    },
    async deleteCampaign(id) {
      const res = await campaignServices.delete(id);
      if(res.error){
        this.responseToast('DELETE', 'error', res);
        return ;
      }
      this.responseToast('DELETE', 'success');
      this.getCampaigns(this.pages.current_page);
    },
    confirmDeleteCampaign(item) {
      this.$dialog
        .confirm( item.name + ' isimli kampanyayı silmek üzeresiniz, onaylıyor musunuz?', {
          loader: true,
          okText: "Sil",
          cancelText: "Vazgeç"
        })
        .then(dialog => {
          this.deleteCampaign(item.id);
          dialog.close();
        })
        .catch(dialog => {
          dialog.close();
        });
    },
    splitQuery(q) {
      let page = 1;
      if(q.sayfa) {
        page = parseInt(q.sayfa);
      }
      this.getCampaigns(page);
    },
    show(item) {
      this.redirectTo('/kampanya/'+item.id)
    }
  },
  created () {
    this.isMobile = this.checkIsMobile();
    this.splitQuery(this.$route.query);
  }
}
</script>